// src/Components/Header.js
import React from "react";
import logo from '../../assets/vodafone-logo.png'; // Place logo in src/assets
import { useMsal } from "@azure/msal-react";


function Header({ userEmail }) {
  const { instance, accounts } = useMsal();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    instance.logoutRedirect();
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <img src={logo} alt="Vodafone Logo" className="vodafone-logo" />
        </div>
        <div className="header-user-email">{userEmail}</div>

        <button onClick={handleLogout}>
          Sign Out ({accounts[0].name})
        </button>
      </div>
    </header>
  );
}

export default Header;
